/**
 * DataTables language packs, applied without touching the theme's app-invoice.js.
 *
 *  - new tables pick the strings up through `$.fn.dataTable.defaults`
 *  - tables that already exist get their settings patched and are redrawn
 *  - the search box placeholder is hard-coded by the theme init, so it is re-applied on `init.dt`
 */
const PACKS = {
    'en': {
        search: '', searchPlaceholder: 'Search',
        paginate: { first: 'First', last: 'Last', next: 'Next', previous: 'Previous' },
        emptyTable: 'No data available in table',
        zeroRecords: 'No matching records found',
        info: 'Showing _START_ to _END_ of _TOTAL_ entries',
        infoEmpty: 'Showing 0 to 0 of 0 entries',
        infoFiltered: '(filtered from _MAX_ total entries)',
        lengthMenu: 'Show _MENU_ entries',
        loadingRecords: 'Loading...',
        processing: 'Processing...',
        aria: { sortAscending: ': activate to sort column ascending', sortDescending: ': activate to sort column descending' },
    },
    'zh-TW': {
        search: '', searchPlaceholder: '搜尋',
        paginate: { first: '第一頁', last: '最後一頁', next: '下一頁', previous: '上一頁' },
        emptyTable: '目前沒有資料',
        zeroRecords: '沒有符合的資料',
        info: '顯示第 _START_ 至 _END_ 筆，共 _TOTAL_ 筆',
        infoEmpty: '顯示第 0 至 0 筆，共 0 筆',
        infoFiltered: '（從 _MAX_ 筆資料中篩選）',
        lengthMenu: '每頁顯示 _MENU_ 筆',
        loadingRecords: '載入中...',
        processing: '處理中...',
        aria: { sortAscending: '：升冪排序', sortDescending: '：降冪排序' },
    },
    'zh-CN': {
        search: '', searchPlaceholder: '搜索',
        paginate: { first: '首页', last: '末页', next: '下一页', previous: '上一页' },
        emptyTable: '暂无数据',
        zeroRecords: '没有匹配的记录',
        info: '显示第 _START_ 至 _END_ 条，共 _TOTAL_ 条',
        infoEmpty: '显示第 0 至 0 条，共 0 条',
        infoFiltered: '（从 _MAX_ 条记录中筛选）',
        lengthMenu: '每页显示 _MENU_ 条',
        loadingRecords: '加载中...',
        processing: '处理中...',
        aria: { sortAscending: '：升序排列', sortDescending: '：降序排列' },
    },
    'ja': {
        search: '', searchPlaceholder: '検索',
        paginate: { first: '先頭', last: '最終', next: '次へ', previous: '前へ' },
        emptyTable: 'データがありません',
        zeroRecords: '一致するレコードがありません',
        info: '_TOTAL_ 件中 _START_ 〜 _END_ 件を表示',
        infoEmpty: '0 件中 0 〜 0 件を表示',
        infoFiltered: '（全 _MAX_ 件より抽出）',
        lengthMenu: '_MENU_ 件表示',
        loadingRecords: '読み込み中...',
        processing: '処理中...',
        aria: { sortAscending: '：昇順に並べ替え', sortDescending: '：降順に並べ替え' },
    },
};

let current = PACKS.en;
let hooked = false;

function jq() {
    const $ = (typeof window !== 'undefined') && (window.jQuery || window.$);
    return ($ && $.fn && $.fn.dataTable) ? $ : null;
}

function setPlaceholder($, settings) {
    try {
        $(settings.nTableWrapper).find('.dataTables_filter input').attr('placeholder', current.searchPlaceholder);
    } catch (e) { /* ignore */ }
}

/** Switch every DataTable (existing and future) to the strings of `code`. Safe to call when DataTables is absent. */
export function applyDataTablesLocale(code) {
    current = PACKS[code] || PACKS.en;
    const $ = jq(); if (!$) return;

    // future tables
    $.extend(true, $.fn.dataTable.defaults, { language: $.extend(true, {}, current) });

    // the theme init hard-codes `searchPlaceholder`, so re-apply ours once a table is built
    if (!hooked) {
        hooked = true;
        $(document).on('init.dt', (e, settings) => settings && setPlaceholder($, settings));
    }

    // existing tables: patch their (Hungarian-notation) language settings and redraw
    try {
        const internal = $.fn.dataTable.ext && $.fn.dataTable.ext.internal;
        const converted = { language: $.extend(true, {}, current) };
        if (internal && internal._fnCamelToHungarian) internal._fnCamelToHungarian($.fn.dataTable.defaults, converted, true);
        const api = $.fn.dataTable.tables({ visible: false, api: true });
        api.settings().each(settings => {
            if (converted.oLanguage) $.extend(true, settings.oLanguage, converted.oLanguage);
            setPlaceholder($, settings);
        });
        api.draw(false);
    } catch (e) { /* no table yet, nothing to patch */ }
}
